import { assert_is_safe_number, assert_string_object_id } from '@shared/asserts/utils_asserts';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { FIELD__base } from '../generation/graph_invoke/_fields/_base/FIELD__base';
import { FIELD_PRIMITIVE__int } from '../generation/graph_invoke/_fields/_primitives/number/FIELD_PRIMITIVE__int';
import { DTO__grid2d_cell } from './DTO__grid2d_cell';

export class DTO__grid2d_cell_generation extends DTO__grid2d_cell {
  /*
   * STATIC FIELDS
   */
  static _class_name_static: string = ENUM__dto_class_name.GRID2D_CELL_GENERATION;

  /*
   * DB FIELDS
   */

  x!: number;
  y!: number;

  field_hash__value_full!: string;

  field_row!: FIELD__base;
  field_column!: FIELD__base;

  /*
   * PROPERTIES
   */

  get is_already_generated_on_any_generation() {
    return !this.hash_sha256_content.is_empty_hash_sha256();
  }

  get is_already_generated_on_other_generation() {
    if (this.is_already_generated_on_this_generation) return false;

    return this.is_already_generated_on_any_generation;
  }

  get is_already_generated_on_this_generation() {
    return !this._id.is_empty_object_id();
  }

  /*
   * METHODS
   */

  constructor() {
    super();

    this.field_row = FIELD_PRIMITIVE__int.CREATE_STUB();
    this.field_column = FIELD_PRIMITIVE__int.CREATE_STUB();
  }

  is_image_generated_on_generation(generation_id: string): boolean {
    if (!this._id) return false;
    if (this.hash_sha256_content.is_empty_hash_sha256()) return false;

    return this.grid2d_id == generation_id;
  }

  get_key_for_generation(): string {
    assert_string_object_id(this.grid2d_id);

    assert_is_safe_number(this.x);
    assert_is_safe_number(this.y);

    return `${this.grid2d_id}_${this.x}_${this.y}`;
  }

  is_equal(other: DTO__grid2d_cell_generation) {
    return this.get_key_for_generation() == other.get_key_for_generation();
  }

  toString(): string {
    return `${this.x}x${this.y}`;
  }
}
